module.exports = __webpack_public_path__ + "img/style_default.1faa1bec.png";